const APP_CONFIG = {
  HEADER_HEIGHT: 88,
};

export default APP_CONFIG;
